import React, { useEffect } from "react"
import { Button } from "antd"
import OtpInput from "../../../shared-components/adminSharedComp/adminModals/DepositoModal/OtpInput"

const OtpVerification = ({ value, error, loading, onChange, onVerify, onBack }) => {
  const isMrPayCard = process.env.REACT_APP_IS_MRPAY_CARD === "true"

  const handleSubmit = (e) => {
    e.preventDefault()

    if (value.length === 6 && !loading) {
      onVerify()
    }
  }

  return (
    <form className="OtpVerification" onSubmit={handleSubmit}>
      <p className="OtpVerification__description">
        Inserisci il codice OTP a 6 cifre generato dalla tua applicazione
        Authenticator.
      </p>
      <OtpInput
        value={value}
        onChange={onChange}
        onEnter={onVerify}
        disabled={loading}
      />

      {error && <div className="OtpVerification__error">{error}</div>}

      <Button
        htmlType="submit"
        type="primary"
        block
        loading={loading}
        disabled={value.length !== 6}
        className="OtpVerification__button"
        style={
          isMrPayCard
            ? {
                marginTop: "30px",
                background: "#011240",
              }
            : {
                marginTop: "30px",
              }
        }
      >
        Verifica
      </Button>

      <p
        className="forgot-pass"
        onClick={onBack}
        style={isMrPayCard ? { color: "#011240", marginTop: 20 } : { marginTop: 20 }}
      >
        Torna al login
      </p>
    </form>
  )
}

export default OtpVerification
